import { memo, useRef } from 'react';
import classnames from 'classnames';

import { DrawerBodyProps } from '../drawer.types';

import * as S from './drawer-body.styles';
import { useBodyScroll } from './use-body-scroll';

export const DrawerBody = memo(function DrawerBody({
  children,
  id,
  headerKeyline,
}: DrawerBodyProps) {
  const ref = useRef<HTMLDivElement>(null);
  const { isOverflowing } = useBodyScroll(ref, { headerKeyline });

  return (
    <S.DrawerBodyWrapper id={id} ref={ref}>
      {children}
      <S.DrawerScrollFade
        id="scroll-fade"
        className={classnames({ hidden: !isOverflowing })}
      />
    </S.DrawerBodyWrapper>
  );
});
